<template>
  <section :class="b({ mix: className, withoutShadow, isMobileView })">
    <img
      :class="b('image', { mix: classNameImage, isMobileView })"
      :src="imageSrc"
      :alt="alt || 'alt-text'"
    />
    <div
      v-if="withGradient"
      :class="b('gradient', {
        mix: classNameGradient,
        dark: isDarkGradient,
        horizon: isHorizonGradient,
        blue: isBlueGradient,
        isMobileView,
      })"
    />
    <div
      v-if="text"
      :class="b('text', {
        mix: classNameText,
        white: isDarkGradient || isHorizonGradient || isBlueGradient,
        isMobileView,
      })"
    >
      <!-- Режим редактирования -->
      <a-input
        v-if="isEdit"
        :class="b('text-input')"
        placeholder="Enter image text"
        v-model:value="editableText"
        @input="updateText"
      />
      <!-- Обычный режим -->
      <span v-else>
        {{ text }}
      </span>
    </div>
  </section>
</template>

<script>
import bem from '@/utils/bem';
import useMobileStyle from '@/mixins/useMobileStyle';
import styles from './custom-image-style.scss';

const b = bem('custom-image', styles);

export default {
  name: 'CustomImage',
  mixins: [useMobileStyle],
  props: {
    className: {
      type: String,
      default: '',
    },
    classNameImage: {
      type: String,
      default: '',
    },
    classNameGradient: {
      type: String,
      default: '',
    },
    classNameText: {
      type: String,
      default: '',
    },
    imageUri: {
      type: [String, Object],
      default: '',
    },
    alt: {
      type: String,
      default: 'this is image',
    },
    withoutShadow: {
      type: Boolean,
      default: false,
    },
    withGradient: {
      type: Boolean,
      default: false,
    },
    isDarkGradient: {
      type: Boolean,
      default: false,
    },
    isHorizonGradient: {
      type: Boolean,
      default: false,
    },
    isBlueGradient: {
      type: Boolean,
      default: false,
    },
    text: {
      type: [String, Object],
      default: '',
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editText: {
      type: String,
      default: '',
    },
  },
  computed: {
    b() {
      return b;
    },
    imageSrc() {
      if (this.imageUri instanceof Object && this.isMobileDisplay && this.imageUri.srcMob) {
        return this.imageUri.srcMob || this.imageUri.src;
      }
      if (this.imageUri instanceof Object) {
        return this.imageUri.src;
      }
      return this.imageUri;
    },
    editableText: {
      get() {
        return this.editText;
      },
      set(value) {
        this.$emit('update-text', value);
      },
    },
  },
  methods: {
    updateText(event) {
      this.$emit('update-text', event.target.value);
    },
  },
  data() {
    return {
      size: 1024,
    };
  },
};
</script>
